export default class Coordinator {
  constructor ({ x, y, width, height }) {
    this.left = x;
    this.top = y;
    this.width = width;
    this.height = height;
  }

  getBottom () {
    return this.top + this.height;
  }

  getRight () {
    return this.left + this.width;
  }

  clone () {
    return new Coordinator({ x: this.left, y: this.top, width: this.width, height: this.height });
  }
}
